import { ReactNode } from 'react';
import styles from '@components/Heading/Heading.styles';
type PropsType = {
  children?: ReactNode;
  h?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  headingType?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  subHeadingType?: 1;
  display?: 1 | 2 | 3 | 4 | 5;
  mobile?: boolean;
  size?: number | null;
  color?: string | null;
  bold?: boolean;
  uppercase?: boolean;
  align?: 'left' | 'center' | 'right';
  pb?: number | string[] | number[];
  addSx?: Record<string, unknown>;
  whiteSpace?: 'normal' | 'nowrap' | 'pre' | 'pre-wrap' | 'pre-line' | 'break-spaces';
  capitalize?: boolean;
  dangerouslySetInnerHTML?: {
    __html: string;
  };
  id?: string;
  className?: string;
  'data-testid'?: string;
};
const Heading = ({
  children = '',
  h = 2,
  headingType = undefined,
  subHeadingType = undefined,
  display = undefined,
  mobile = false,
  size = null,
  color = null,
  bold = false,
  uppercase = false,
  align = undefined,
  pb = 0,
  addSx = {},
  whiteSpace = 'normal',
  capitalize = false,
  dangerouslySetInnerHTML = undefined,
  id = undefined,
  className = '',
  'data-testid': dataTestId = undefined
}: PropsType) => {
  const displayMode = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
    6: 'six',
    7: 'seven'
  };
  const CustomHeading = `h${h}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  const headingClass = headingType ? `headings heading__${displayMode[headingType]}` : '';
  const subHeadingClass = subHeadingType ? `headings sub_heading__${displayMode[subHeadingType]}` : '';
  const displayClass = display ? `display__${displayMode[display]}` : '';
  const mobileClass = mobile ? 'mobile' : '';
  const boldClass = bold ? 'bold' : '';
  if (dangerouslySetInnerHTML) {
    return <CustomHeading id={id} className={`${headingClass} ${displayClass} ${subHeadingClass} ${boldClass} ${mobileClass} ${className}`} sx={{
      ...styles.heading(size, color, uppercase, align, pb, whiteSpace, capitalize),
      ...addSx
    }} dangerouslySetInnerHTML={dangerouslySetInnerHTML} data-testid={dataTestId || 'heading'} />;
  }
  return <CustomHeading id={id} className={`${headingClass} ${displayClass} ${subHeadingClass} ${boldClass} ${mobileClass} ${className}`} sx={{
    ...styles.heading(size, color, uppercase, align, pb, whiteSpace, capitalize),
    ...addSx
  }} data-testid={dataTestId || 'heading'}>
      {children}
    </CustomHeading>;
};
export default Heading;